<template>
  <form
    autocomplete="off"
    @submit.prevent="handleSubmit"
  >
    <div>
      <div class="mb-4 input-field">
        <label for="password">New password</label>
        <PasswordInput
          id="password"
          v-model="formData.password"
        />
      </div>

      <div class="mb-4 input-field">
        <label for="confirmPassword">Confirm password</label>
        <PasswordInput
          id="confirmPassword"
          v-model="formData.confirmPassword"
        />
      </div>

      <AppButton
        class="btn-solid-primary"
        :disabled="!canSubmit"
        :class="{ 'opacity-50': !canSubmit }"
      >
        {{ isSubmitting ? 'Setting password...' : 'Set password' }}
      </AppButton>
    </div>
  </form>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { computed, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppButton } from '@/components/buttons';
import { PasswordInput } from '@/components/form-inputs';

import { useHttp, useToasts } from '@/composables';

const emit = defineEmits(['password-set']);

const route = useRoute();
const toasts = useToasts();

const formData = reactive({
  password: import.meta.env.DEV ? 'J0hnCena!!!' : null,
  confirmPassword: import.meta.env.DEV ? 'J0hnCena!!!' : null,
});

const isSubmitting = ref(false);
const canSubmit = computed(() => !isSubmitting.value && formData.password !== '' && formData.confirmPassword === formData.password);

const handleSubmit = async () => {
  isSubmitting.value = true;

  const response = await useHttp().post(
    '/auth/password-reset',
    { token: route.query.token, password: formData.password },
  );

  if (response.statusCode === HttpStatusCode.Ok) {
    emit('password-set');
  } else {
    toasts.error(response.errors.password ? response.errors.password[0] : response.errors.token[0]);
  }

  isSubmitting.value = false;
};
</script>
